import React from 'react'
import {useFormContext} from "react-hook-form";
import cn from "classnames";
import "./UiInputToggle.scss";

export default function UiInputToggle({ label, name, size, onText, offText, linkComponent, asTable, ...rest }: any){
    const formContext = useFormContext();
    const { register, watch } = formContext;
    const LinkComponent = linkComponent as JSX.Element;

    const ligado = !!watch(name);
    const textoEstado = ligado ? (onText ?? 'Sim') : (offText ?? 'Não');

    return (
        <div className={cn(`col-lg-${(size) ? size : 12}`, 'ui-input-toggle', { 'as-table': asTable })}>
            <div className="form-item">
                { !asTable &&
                    <label className="form-label" htmlFor={name}>{label}{
                        LinkComponent &&
                        // @ts-ignore
                        <LinkComponent formContext={formContext} name={name}/>
                    }
                    </label>
                }
                <div className="field-container">
                    <label className={cn('toggle', { disabled: rest.disabled })}>
                        <input type="checkbox" id={name} role="switch" {...register(name)} {...rest} />
                        <span className="toggle-track">
                            <span className="toggle-knob"/>
                        </span>
                        { (onText || offText) && <span className="toggle-text">{textoEstado}</span> }
                    </label>
                </div>
            </div>
        </div>
    )
}
